module.exports = __webpack_public_path__ + "static/media/menu.8fe412ac.svg";